module.exports = __webpack_public_path__ + "img/6.dbb4eed3.jpg";